import {InMemoryCache, PossibleTypesMap} from '@apollo/client';
import {objectFromEntries, entry} from '@benchling/js-utils';

import dataIdFromBenchlingObject from './dataIdFromBenchlingObject';
import GraphQLIntrospectionResult from './schema/GraphQLIntrospectionResult';
import {IntrospectionAbstractType, typeIsAbstract} from './schema/util/SchemaOps';
import typePolicies from './typePolicies';

export default function createInMemoryCache(): InMemoryCache {
  const abstractTypes = GraphQLIntrospectionResult.__schema.types.filter((t) =>
    typeIsAbstract(t)
  ) as Array<IntrospectionAbstractType>;

  const possibleTypeEntries = abstractTypes
    .filter((type) => type.possibleTypes)
    .map((type) =>
      entry<Array<string>>(
        type.name,
        type.possibleTypes.map((subtype) => subtype.name)
      )
    );

  const possibleTypes: PossibleTypesMap = objectFromEntries(possibleTypeEntries);

  return new InMemoryCache({
    possibleTypes,
    typePolicies,
    dataIdFromObject: dataIdFromBenchlingObject,
  });
}
